<template>
    <v-stepper v-model="currentStep" class="mt-3">
        <v-stepper-header>
            <v-stepper-step :complete="stepsComplete.step1 && currentStep >= 1" step="1"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="stepsComplete.step2 && currentStep >= 2" step="2"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="stepsComplete.step3  && currentStep >= 3" step="3"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="stepsComplete.step4  && currentStep >= 4" step="4"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="stepsComplete.step5  && currentStep >= 5" step="5"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="stepsComplete.step6  && currentStep >= 6" step="6"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="stepsComplete.step7  && currentStep >= 7" step="7"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="stepsComplete.step8  && currentStep >= 8" step="8"></v-stepper-step>
            <v-divider></v-divider>
            <v-stepper-step :complete="stepsComplete.step9  && currentStep >= 9" step="9"></v-stepper-step>
        </v-stepper-header>
        <v-stepper-items>
            <v-stepper-content :step="currentStep">
                <template v-if="loading">
                    <v-row>
                        <v-spacer></v-spacer>
                        <v-col cols="auto">
                            <v-progress-circular color="primary" indeterminate class="ml-auto"></v-progress-circular>
                        </v-col>
                        <v-spacer></v-spacer>
                    </v-row>
                </template>
                <template v-else>
                    <slot></slot>
                </template>
            </v-stepper-content>
        </v-stepper-items>
    </v-stepper>
</template>

<script>
import {mapGetters} from 'vuex';

export default {
    components: {},
    props: {
        currentStep: [Number, String],
        loading: Boolean,
    },
    data: () => ({}),
    computed: {
        ...mapGetters(['stepsComplete']),
    },
};
</script>
